import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class WalletPointsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }


  getUserPoints(): Observable<any> {
    return this.http.get(`${this.apiUrl}/wallet/user_points`)
      .pipe(
        map((response: any) => response?.data || []),
        catchError(error => throwError(error))
      );
  }

  setInvoiceWallet(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/set_invoice_wallet`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  removeInvoiceWallet(invoiceId) {
    return this.http.post(`${this.apiUrl}/wallet/remove_invoice_wallet/${invoiceId}`, null)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

}
